/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useAppProviderContext, useDropOffLocationContext } from '../../core/application/contexts'
import AutocompleteSuggestion from '../../core/domain/models/AutocompleteSuggestion'
import DropdownWrapper from '../shared/DropDownWrapper'
import DropOffLocationSuggestionList from '../shared/DropOffLocationSuggestion'
import SearchInput from '../shared/SearchInput'

interface SearchInputWrapperProps {
  placeholder?: string
  onSelect: (suggestion: AutocompleteSuggestion, cb: () => void) => void
}

const SearchInputWrapper: FC<SearchInputWrapperProps> = (props) => {
  const { placeholder, onSelect } = props
  const { buildContextualQuery } = useDropOffLocationContext()
  const { dropOffProvider, multisearchProvider } = useAppProviderContext()

  const [searchString, setSearchString] = useState<string>('')
  const [suggestionsDetails, setSuggestionsDetails] = useState<AutocompleteSuggestion[]>([])
  const [displayList, setDisplayList] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)

  const onSearchInputChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setSearchString(value)
  }, [])

  useEffect(() => {
    if (searchString.length > 2) {
      if (multisearchProvider && dropOffProvider) {
        setLoading(true)
        multisearchProvider.autocompleteMulti(searchString).then(async (suggestions: AutocompleteSuggestion[]) => {
          const query = buildContextualQuery({
            dropOffIds: suggestions.filter(({ api }) => api === 'store').map(({ id }) => id)
          })
          const filteredDropOffs = (await dropOffProvider.fetchDropOffList({ query })).items
          const filteredIds = filteredDropOffs.map(({ storeId }) => storeId)
          const filteredSuggestion = suggestions.filter(
            (suggestion) => suggestion.api !== 'store' || filteredIds.includes(suggestion.id)
          )
          setSuggestionsDetails(filteredSuggestion)
          setLoading(false)
        })
      }
    } else {
      setSuggestionsDetails([])
    }
  }, [searchString, dropOffProvider, multisearchProvider])

  const onSelectSuggestion = useCallback(
    (suggestion: AutocompleteSuggestion) => {
      onSelect({ ...suggestion }, () => {
        setSearchString(suggestion.description)
        setDisplayList(false)
      })
    },
    [onSelect]
  )

  const onFocus = () => {
    setDisplayList(true)
  }

  const onBlur = useCallback(() => {
    setTimeout(() => {
      setDisplayList(false)
    }, 400)
  }, [])

  return (
    <Container>
      <SearchInput
        placeholder={placeholder}
        value={searchString}
        onChange={onSearchInputChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <DropdownWrapper open={displayList}>
        <DropOffLocationSuggestionList
          suggestions={suggestionsDetails}
          onSelect={onSelectSuggestion}
          loading={loading}
        />
      </DropdownWrapper>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  width: 100%;
`

export default SearchInputWrapper
